export const isDev = (): boolean => {
	return process.env.RUN_ENV === 'development';
};

export const isCI = (): boolean => {
	return process.env.RUN_ENV === 'ci';
};
